import type { AnchorHTMLAttributes } from 'react'
import { createLink, LinkComponent } from '@tanstack/react-router'
import type { VariantProps } from 'class-variance-authority'
import { buttonVariants } from 'ui/button'
import { cn } from 'ui/lib/utils'

export type LinkButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> &
  VariantProps<typeof buttonVariants> & {
    ref: React.RefObject<HTMLAnchorElement>
  }

const BasicLinkComponent = ({ variant, size, className, ...props }: LinkButtonProps) => (
  <a className={cn(buttonVariants({ variant, size, className }))} {...props} />
)

const CreatedLinkComponent = createLink(BasicLinkComponent)

export const LinkButton: LinkComponent<typeof BasicLinkComponent> = props => (
  <CreatedLinkComponent preload="intent" {...props} />
)
